module.exports = __webpack_public_path__ + "static/Sukumaran-500bcc72cbb8a585c73faf646e0f1891.jpg";